import { render, staticRenderFns } from "./videoplays.vue?vue&type=template&id=1b4518f2&scoped=true&"
import script from "./videoplays.vue?vue&type=script&lang=js&"
export * from "./videoplays.vue?vue&type=script&lang=js&"
import style0 from "./videoplays.vue?vue&type=style&index=0&id=1b4518f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4518f2",
  null
  
)

export default component.exports